// extracted by mini-css-extract-plugin
export default {"container":"styles_container__XNEdF","packageSelect":"styles_packageSelect__0zkkh"};